export const destinations = {
    title: "Destinations",
    sortName: "Name",
    noResults: "Geen resultaten gevonden",
    tryDifferentSearch: "Probeer een andere zoekopdracht"
};
